import React from 'react'

function TenderTextCooling() {
  return (
    <embed src="\pdfs\EAT2.1.1.1_SKS-4-3_Static_Cooling_Ceiling_System_kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextCooling